export const classes = {
  background: 'absolute inset-0 overflow-hidden',
  blob: 'absolute rounded-full blur-3xl',
  orangeBlob: 'top-0 left-[10%] size-96 bg-orange-300/80 dark:bg-orange-300/50',
  purpleBlob:
    'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[600px] bg-purple-200/60 dark:bg-purple-200/40',
  blueBlob: 'bottom-0 right-1/4 size-96 bg-blue-200 dark:bg-blue-200/50',
  greenBlob: 'top-0 right-0 size-[600px] bg-green-1/60 dark:bg-green-1/40',
};

export const styles = {
  blob: (animation: string) => ({
    animation: `${animation} 10s infinite`,
  }),
};

export const BLOBS = [
  [classes.orangeBlob, styles.blob('orange-blob-warp')],
  [classes.purpleBlob, styles.blob('purple-blob-warp')],
  [classes.blueBlob, styles.blob('blue-blob-warp')],
  [classes.greenBlob, styles.blob('green-blob-warp')],
] as const;
